import {
  TokenRefreshTimeoutError,
  InvalidTokenError,
} from 'embeddings/HostMessageControllerErrors';

/**
 * Checks if an action error is a 401 Unauthorized error
 * @param {Object} action - Redux action object
 * @returns {boolean} True if the action represents a 401 error
 */
export function isInvalidTokenRejection(action) {
  if (action.type.startsWith('fusion/') && action.type.endsWith('/rejected')) {
    // these are rejections dispatched by the fusionApi with RTK Query
    return [401, 418].includes(action.payload?.status);
  }

  // match on Axios errors thrown within an async thunk
  return (
    [401, 418].includes(action.error?.status) || // errors that have been serialized with thunkErrorSerializer will have the status property
    (action.error?.name === 'AxiosError' && // errors that use the default serializer can only be matched by name and message
      ['Request failed with status code 418', 'Request failed with status code 401'].includes(
        action.error?.message
      ))
  );
}

export function isTokenRefreshTimeout(action) {
  return action.error?.name === TokenRefreshTimeoutError.name;
}

export function isInvalidToken(action) {
  return action.error?.name === InvalidTokenError.name;
}
